'use client'

import { useActionState } from 'react'
import Link from 'next/link'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'
import { register } from '@/app/actions/auth'

export default function RegisterPage() {
  const [state, formAction, pending] = useActionState(register, null)

  if (state?.success) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Card className="w-full max-w-md">
          <CardHeader>
            <CardTitle className="text-2xl text-center">確認メールを送信しました</CardTitle>
          </CardHeader>
          <CardContent className="text-center space-y-4">
            <p className="text-gray-600">
              <span className="font-medium">{state.email}</span> に確認メールを送りました。
            </p>
            <p className="text-sm text-gray-500">
              メール内のリンクをクリックして登録を完了してください。
              <br />
              届かない場合は迷惑メールフォルダをご確認ください。
            </p>
            <Link href="/login" className="text-blue-600 hover:underline text-sm">
              ログインページへ
            </Link>
          </CardContent>
        </Card>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-2xl text-center">新規登録</CardTitle>
        </CardHeader>
        <CardContent>
          <form action={formAction} className="space-y-4">
            {state?.error && (
              <div className="p-3 rounded bg-red-50 border border-red-200 text-red-700 text-sm">
                {state.error}
              </div>
            )}
            <div className="space-y-2">
              <Label htmlFor="name">お名前</Label>
              <Input id="name" name="name" type="text" required placeholder="山田 太郎" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="email">メールアドレス</Label>
              <Input id="email" name="email" type="email" required placeholder="your@email.com" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">パスワード</Label>
              <Input id="password" name="password" type="password" required minLength={8} placeholder="8文字以上" />
            </div>
            <Button type="submit" className="w-full" disabled={pending}>
              {pending ? '登録中...' : '登録する'}
            </Button>
          </form>
          <p className="mt-4 text-center text-sm text-gray-600">
            すでにアカウントをお持ちの方は{' '}
            <Link href="/login" className="text-blue-600 hover:underline">
              ログイン
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
